const isStringCode = `import { isString } from 'cristatus';

const isString = isString("hello"); // true
`;

export default isStringCode;
